import { Popover } from "antd";
import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_CUSTOMER } from "@assets/svgs/ICON_CUSTOMER.svg";
import { ReactComponent as ICON_DISPLAY_SETTING } from "@assets/svgs/ICON_DISPLAY_SETTING.svg";
import { ReactComponent as ICON_TABLE_DELETE } from "@assets/svgs/ICON_TABLE_DELETE.svg";
import { ReactComponent as ICON_TABLE_EDIT } from "@assets/svgs/ICON_TABLE_EDIT.svg";
import { Icon } from "@components/Icon";
import {
  KEY_USERS_MANAGEMENTS_USERS_UPDATE,
  KEY_USERS_MANAGEMENTS_USERS_DELETE,
  KEY_USERS_MANAGEMENTS_USERS_LOCATION,
} from "@static/PERMISSION_KEY";

const SectionTableAction = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const BASE_USER_TABLE_COLUMNS = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    fixed: "left",
    width: 80,
    sorter: (a, b) => a.index - b.index,
  },
  {
    title: "Username",
    dataIndex: "username",
    key: "username",
    fixed: "left",
  },
  {
    title: "Role",
    dataIndex: ["role", "name"],
    key: "role",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Customer",
    dataIndex: ["categoryCustomer", "customer_name"],
    key: "categoryCustomer",
    width: 280,
    sorter: (a, b) => {
      const nameA = _.get(
        a,
        ["categoryCustomer", "customer_name"],
        ""
      ).toLowerCase();
      const nameB = _.get(
        b,
        ["categoryCustomer", "customer_name"],
        ""
      ).toLowerCase();
      return nameA.localeCompare(nameB);
    },
  },
];

export const getUserTableColumns = ({
  permission,
  userType,
  onHandleEdit,
  onHandleManageLocation,
  onHandleManageCustomer,
  onHandleDelete,
  showConfirmation,
}) => {
  // const userColumns =
  //   userType === "OWNER"
  //     ? [...BASE_USER_TABLE_COLUMNS]
  //     : _.filter(BASE_USER_TABLE_COLUMNS, (item) => {
  //         return _.get(item, ["key"]) !== "categoryCustomer";
  //       });
  const userColumns = [...BASE_USER_TABLE_COLUMNS];

  return [
    ...userColumns,
    {
      title: "Actions",
      key: "actions",
      width: 120,
      // align: "center",
      render: (text, item, index) => {
        return (
          <SectionTableAction key={index}>
            {_.includes(permission, KEY_USERS_MANAGEMENTS_USERS_LOCATION) && (
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Manage Customer</div>}
              >
                <ICON_CUSTOMER
                  width={24}
                  height={24}
                  onClick={() => onHandleManageCustomer({ item })}
                />
              </Popover>
            )}
            {_.includes(permission, KEY_USERS_MANAGEMENTS_USERS_LOCATION) && (
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Manage Location</div>}
              >
                <ICON_DISPLAY_SETTING
                  width={24}
                  height={24}
                  onClick={() => onHandleManageLocation({ item })}
                />
              </Popover>
            )}
            {_.includes(permission, KEY_USERS_MANAGEMENTS_USERS_UPDATE) && (
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Edit</div>}
              >
                <ICON_TABLE_EDIT
                  width={24}
                  height={24}
                  onClick={() => onHandleEdit({ item })}
                />
              </Popover>
            )}
            {_.includes(permission, KEY_USERS_MANAGEMENTS_USERS_DELETE) && (
              // <Icon
              //   isCursor
              //   width={24}
              //   height={24}
              //   onClick={() =>
              //     showConfirmation({
              //       onConfirm: () => onHandleDelete({ item }),
              //     })
              //   }
              // >
              //   <ICON_TABLE_DELETE />
              // </Icon>
              <Popover
                placement="top"
                trigger="hover"
                content={<div>Delete</div>}
              >
                <ICON_TABLE_DELETE
                  width={24}
                  height={24}
                  onClick={() =>
                    showConfirmation({
                      title: "Delete",
                      onConfirm: () => onHandleDelete({ item }),
                    })
                  }
                />
              </Popover>
            )}
          </SectionTableAction>
        );
      },
    },
  ];
};
